/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqSecondaryNav() {
	const CMS_API_URI = Config.secondaryNavbarRoute;
	try {
		const response = await axios.get(CMS_API_URI);
		return response.data;
	} catch (error) {
		console.error(error);
		return error;
	}
}

export default {
	reqSecondaryNav
};